import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store/index'
import NProgress from 'nprogress'

Vue.use(VueRouter)

// Define Route
const router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/',
            name: 'dashboard',
            alias: '/dashboard',
            component: () => import('./views/Dashboard.vue'),
        },
        {
            path: '/referensi/dokter',
            name: 'referensi.dokter',
            component: () => import('./views/Referensi/Dokter.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/referensi/poli-simrs',
            name: 'referensi.poli',
            component: () => import('./views/Referensi/Poli.vue'),
            meta: {
                auth: true
            }
        },
        {
            path: '/referensi/jadwal-dokter',
            name: 'referensi.jadwalDokter',
            component: () => import('./views/Referensi/JadwalDokter.vue'),
            meta: {
              auth: true
            }
        },
        {
            path: '/antrean/tambah-antrean',
            name: 'antrean.tambahAntrean',
            component: () => import('./views/Antrean/Tambah.vue'),
            meta: {
              auth: true
            }
        },
        {
            path: '/antrean/update-waktu-antrean',
            name: 'antrean.updateWaktuAntrean',
            component: () => import('./views/Antrean/UpdateWaktuAntrean.vue'),
            meta: {
              auth: true
            }
        },
        {
            path: '/antrean/getlisttaskid',
            name: 'antrean.getlisttaskid',
            component: () => import('./views/Antrean/ListWaktuTaskId.vue'),
            meta: {
              auth: true
            }
        },
        {
            path: '/antrean/batal-antrean',
            name: 'antrean.batalantrean',
            component: () => import('./views/Antrean/BatalAntrean.vue'),
            meta: {
              auth: true
            }
        },
        {
            path: '/auth/login',
            name: 'auth.login',
            component: () => import('./views/Auth/Login.vue'),
            meta: {
               guest: true
            }
        },
        {
            path: '/auth/register',
            name: 'auth.register',
            component: () => import('./views/Auth/Register.vue')
        }
    ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (store.getters.isLoggedIn && store.getters.user) {
        next()
        return
    }
    next('/auth/login')
  }

  if (to.matched.some(record => record.meta.guest)) {
    if (!store.getters.isLoggedIn) {
        next()
        return
    }
    next('/dashboard')
  }

  next()
})

// router.beforeResolve((to, from, next) => {
//   // If this isn't an initial page load.
//   if (to.name) {
//     // Start the route progress bar.
//     NProgress.start()
//   }
//   next()
// })

// router.afterEach((to, from) => {
//   // Complete the animation of the route progress bar.
//   NProgress.done()
// })

export default router
